import type { Settings } from '../types'
import * as L from 'leaflet'

export class MapRenderer {
  private readonly element: HTMLElement
  private readonly map: L.Map

  constructor (element: HTMLElement) {
    this.element = element
  }

  public initialize (settings: Settings): void {
    this.map = L.map(this.element, { renderer: L.canvas() })
      .setView([settings.initialCoordinates.latitude, settings.initialCoordinates.longitude], settings.initialScale)
    this.map.attributionControl.setPrefix('')

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(this.map)
  }

  public getMap (): L.Map {
    return this.map
  }
}
